import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import 'moment-timezone';
// import DatePicker from "react-datepicker"; 
// import "react-datepicker/dist/react-datepicker.css";
// import "react-datetime/css/react-datetime.css";
// import { format } from 'date-fns';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import FilterAffiliate from './filterAffiliate';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import { ROUTE_REFRESH, ROUTE_AFFILIATE_PROFILE, PAGENUMROWS_SUPER, PAGING_END_INDEX, ROUTE_LOGIN_AS, LOGIN_SUPER_ADMIN_GROUP, LOGIN_AFFILIATE_GROUP } from '../../configs/staticConfigs';
import{ MSG_AFFILIATE_DELETE,MSG_NOT_FOUND } from '../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_AFFILIATES, LBL_LOGIN_AS_THIS_USER, LBL_EDIT, LBL_DELETE, LBL_ADD_NEW, LBL_EMAIL, LBL_CONTACT_PERSON, LBL_AFFILIATE_NAME, LBL_CONTACT_NUMBER, LBL_CREATED_DATE, LBL_ACTION, LBL_SLNUM,LBL_ALL, LBL_ACTIVE, LBL_DELETED, LBL_DATE_FROM, LBL_DATE_TO, LBL_FILTER, LBL_CLEAR_FILTERS, LBL_STATUS,LBL_CONFIRM_DELETE } from '../../configs/labelConfigs';

import {affiliateListAction, affiliateDeleteAction} from '../../actions/affiliateActions';
import {clearAction,loginAsAction} from '../../actions/commonActions';
import * as types from '../../actions';

import ModalWindow from '../commons/helpers/modalWindow';
import Paginator from '../commons/helpers/paginator';
import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
import { setStorage } from '../../utils/browserStorage';

import {checkPermissions} from '../../utils/permissions';
import {getSortClass} from '../../utils/commonUtilities'; 

class AffiliateListComponent extends Component {

   constructor(props){
      super(props)

      this.state = {
         activePage:1,
         startIndex : 0, 
         endIndex : PAGING_END_INDEX,
         activeRowId:0,    
         perPageCount:PAGENUMROWS_SUPER,
         sortField:'-id',
         sortOrder:'',  
         isFilterOn: false,
         affiliateId:'',   
         affiliateName:'', 
         toastMessage:'',
         toastFlag:false,
         toastSuccess:true, 
         searchAffiliate:'',
         filterClicked: 0,
         resetFilterClicked: 0,
         applyFilterClicked: 0,
         applyFilter: 0,       
         filtersData: {},  
      }
      this.onShowActionButtons = this.onShowActionButtons.bind(this);
      this.onHideActionButtons = this.onHideActionButtons.bind(this);
      
      this.modalDelete = React.createRef(); 
   }

   onApplyFilterButton = () => {
      let applyFilterClicked = this.state.applyFilterClicked+1; 
      this.setState({applyFilterClicked}); 
   }

   applyFilters = (filtersData) => {
      // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
      let filterApplied = 0; 
      if(filtersData.filtersSelected > 0) filterApplied = 1; 
      let sortOrder = ''; 
      let sortField = '-id'; 
      this.setState({activePage:1, sortOrder:sortOrder, sortField:sortField, applyFilter:filterApplied, filtersData:filtersData}, () => { 
         this.callAffiliateListAction(); 
      }); 
   }

   onResetFiltersButton = () => {   
      let resetFilterClicked = this.state.resetFilterClicked+1; 
      if(this.state.applyFilter > 0) {
         this.setState({resetFilterClicked,applyFilter:0,activePage:1, sortOrder:'', sortField:'-id'}, () => {
               this.callAffiliateListAction(); 
               if(this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.add('active');   
               }
               else if(!this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.remove('active');   
               }
         });
      }
      else {
         this.setState({resetFilterClicked,applyFilter:0}); 
      }
   }

   onFilterClose = () => {
       
   }

   callAffiliateListAction = () => {
      this.props.affiliateListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchAffiliate),filterApplied:this.state.applyFilter,filtersData:this.state.filtersData});
   }

   onSelectStatus = (e) => {
      this.setState({statusActive:e.target.value})
   } 

   onDateCheck = (e) => {
      this.setState({includeDate:!this.state.includeDate}) 
   }

   onStartDateChange = (date) =>{
      let startDate = new Date(date);
      
      if(this.state.selectedEndDate < startDate) {
          this.setState({selectedStartDate:startDate,selectedEndDate:startDate});    
      }
      else {
          this.setState({selectedStartDate:startDate});    
      }
  }

  onEndDateChange = (date) =>{ 
      let endDate = new Date(date);
      this.setState({selectedEndDate:endDate});  
  }

   onShowFilterBy = () => {

      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn }));
      document.getElementById("filterByMenu").classList.toggle('active');
      document.getElementById("filterIcon").classList.toggle('active');   
      let filterByMenu = document.getElementById('filterByMenu');    
      if(this.state.isFilterOn){
            filterByMenu.style.width='580px';
            filterByMenu.style.right='-580px';
      }else{
            filterByMenu.style.width='580px';
            filterByMenu.style.right='0';
      }
   
      // if(this.state.isFilterOn){
      //    document.getElementById("filterIcon").classList.add('las','la-filter');
      //    document.getElementById("filterIcon").classList.remove('fa','fa-filter');
      // }else{
      //    document.getElementById("filterIcon").classList.remove('las','la-filter');
      //    document.getElementById("filterIcon").classList.add('fa','fa-filter');
      // }
      
   }

   onShowActionButtons = (event, rowId) =>{

      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }        
      
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }

   deleteBtnClick = (rowId,name) =>{
      this.setState({
         affiliateId:rowId,
         affiliateName:name          
      }); 
      this.modalDelete.current.handleOpenModal();
   }

   onDeleteAction = () =>{
      let affiliateId = this.state.affiliateId;
      this.props.affiliateDeleteAction(affiliateId);
      this.modalDelete.current.handleModelClose();                    
   } 
   
   onPagePrevious = (e) =>{
      const {
         startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
       
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          }, () => {
            this.callAffiliateListAction(); 
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          }, () => {
            this.callAffiliateListAction(); 
          });  
      }                           
   }

   onPageUp = (e) => {   

      this.setState({
          activePage: Number(e.target.id)                   
      }, () => {
         this.callAffiliateListAction(); 
      });
   }

   onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX; 
      
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }, () => {
            this.callAffiliateListAction(); 
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          }, () => {
            this.callAffiliateListAction(); 
          });  
      }                                   
   }

   onSort = (event,sortKey) =>{        
      let sOrder = '';
      if(this.state.sortField===sortKey){         
         sOrder = (this.state.sortOrder==='-') ? '' : '-';
          this.setState({ sortOrder:sOrder }, () => {
            this.callAffiliateListAction(); 
          });            
      }else{
         this.setState({ sortField:sortKey }, () => {
            this.callAffiliateListAction(); 
         });
      }        
   }
    
   onLoginAs = (e,id,name) =>  {
      let userGroupData = userGroupUrlCheck(this.props.location);
      let userId = 0; 
      if(userGroupData!==undefined){
         userId = userGroupData.user_id; // associate_id
      }

      let dataObj = {loginAs:LOGIN_AFFILIATE_GROUP,profileId:id,profileName:name,saUserId:userId}; 
      //this.props.loginAsAction(dataObj); 
      setStorage('saLoginAsData', JSON.stringify(dataObj));
      window.open(ROUTE_LOGIN_AS, "_blank") //to open new page
   }

   goToAffiliateProfile(e,id) {
      let profileId = '';
      if(id){
         profileId = id;
      }
      this.props.history.push(ROUTE_AFFILIATE_PROFILE+'/'+profileId);
   }

   onModalFormReset = () =>{       
      this.setState({affiliateId:'',affiliateName:''}); 
   }

   onCloseToast = () =>{
      this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
   } 

   onSearchAffiliate = (e)=>{
      let strVal = e.target.value; 
      this.setState({searchAffiliate:strVal}, () => { 
         if(strVal.length >=3 || strVal.length===0) {
            this.callAffiliateListAction(); 
         }
      }); 
   }

   setToasterState(isEnabled,message,isSucces){
      this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
      setTimeout(()=> {
          this.onCloseToast();
      }, 3000);
   }

   setStateUpdate(numRows,totalPage,activity,errorData){
      if(activity===types.AFFILIATE_DELETE_SUCCESS){
         if (numRows===1 && totalPage > 1){
            let page = this.state.activePage-1;
            this.setState({activePage:page}, () => {
               this.callAffiliateListAction(); 
            }) 
        }else{
            this.callAffiliateListAction(); 
        }    
        this.setToasterState(true,MSG_AFFILIATE_DELETE,true);   
      }else if(activity===types.AFFILIATE_DELETE_ERROR){
         this.setToasterState(true,JSON.stringify(errorData),false);
      }   
   } 

   componentDidUpdate(prevProps) {
      const {isFilterOn,numRows,totalPage,activity,errorData} = this.props;    
     
      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click();   
      }else if (activity !== prevProps.activity) {
         this.setStateUpdate(numRows,totalPage,activity,errorData);
         this.props.clearAction();     
      }
   }

   componentDidMount() {
      document.title = LBL_APP_NAME+" - "+LBL_AFFILIATES;
      this.callAffiliateListAction(); 
      document.body.classList.add('body-super'); 
        
   }
   
   render(){

      const {
         activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,affiliateName, filterClicked, resetFilterClicked, applyFilterClicked, applyFilter, includeDate, selectedStartDate, selectedEndDate, statusActive,sortField,sortOrder,      
      } = this.state  

      const { affiliates,totalPage,status} = this.props;   

      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroupId = 0; 
      if(userGroupData!==undefined){
         userGroupId = userGroupData.user_group;  
      }
      let isAffiliateModify = checkPermissions("affiliate","modify");
      let isloginas = checkPermissions("loginas","view");
            
      if(status===401 || status===403){
         return <Redirect to={ROUTE_REFRESH} />;
      }

      let paddingTopPix = 550;

      return(
         <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

               <div className="box">
                  <div className="box-head">

                     <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder="Search" id="my-search-input" onChange={this.onSearchAffiliate} /></label>
                     </div>


                     <div  className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 450, hide: 250 }}
                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            {LBL_FILTER}
                          </Tooltip>}
                        >
                            <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                        </OverlayTrigger>
                     </div>

                     {this.state.applyFilter > 0 && 
                        <div className="text-12 div150" >&nbsp; &nbsp; <Link to="#" onClick={this.onResetFiltersButton} >{LBL_CLEAR_FILTERS}</Link></div>} 

                     <div className="to-right">
                        {isAffiliateModify && <Link to="#" className="btn btn-primary text-white" onClick={e => this.goToAffiliateProfile(e)} >{LBL_ADD_NEW} </Link>}
                     </div>
                  </div>  
                  <div className="box-content">
                     <div className="table-responsive">
                        <table id="data-table" className="table affiliate" style={{width:"100%"}}>
                           <thead>
                              <tr>
                                 <th>{LBL_SLNUM}</th>
                                 <th onClick={(e) => this.onSort(e,'company_name')} className="affiliate-name spanPointer" >{LBL_AFFILIATE_NAME} <i className={sortField=='company_name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th> {/* sorting_asc */}
                                 <th onClick={(e) => this.onSort(e,'associateusers__user__first_name')} className="contact-person spanPointer">{LBL_CONTACT_PERSON} <i className={sortField=='associateusers__user__first_name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'associateusers__user__email')} className="spanPointer">{LBL_EMAIL} <i className={sortField=='associateusers__user__email' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'associateusers__phone_number')} className="contact-number spanPointer">{LBL_CONTACT_NUMBER} <i className={sortField=='associateusers__phone_number' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'created_on')} className="created-date spanPointer">{LBL_CREATED_DATE} <i className={sortField=='created_on' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 {isAffiliateModify && <th className="action">{LBL_ACTION}</th>}
                              </tr>
                           </thead>
                           <tbody>
                           {(this.props.count===0) && 
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                           }
                           { affiliates.map((item, index)  => {
                              let contactPerson = '';
                              let contactNumber = '';
                              let contactEmail = '';
                              let isEmailVerified = '';
                              let indeNum = (PAGENUMROWS_SUPER*(activePage-1))+index+1;

                              if(item.associateusers_set.length>0){
                                 let associateusers = item.associateusers_set.filter((user) => user != null);
                                 contactPerson = associateusers[0].user.first_name+' '+associateusers[0].user.last_name;
                                 contactNumber = associateusers[0].phone_number;
                                 contactEmail  = associateusers[0].user.email;
                                 isEmailVerified = associateusers[0].email_verified===false?'Not Verified':'';
                              } 
                                    return (
                                        <tr key={item.id}>
                                           <td>{indeNum}</td>
                                           {isAffiliateModify &&
                                            <td><Link to="#" onClick={(e) => this.goToAffiliateProfile(e,item.id)}>{item.company_name}</Link></td>
                                           }{!isAffiliateModify &&
                                            <td>{item.company_name}</td>
                                           }
                                            
                                            <td>{contactPerson}</td>
                                            <td>{contactEmail}<small className="block text-red">{isEmailVerified}</small></td>
                                            <td>{contactNumber}</td>
                                            <td>
                                               <Moment format="DD/MM/YYYY HH:mm">{item.created_on}</Moment>
                                             </td>
                                            <td>
                                            {isAffiliateModify &&
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                    >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                      {userGroupId===LOGIN_SUPER_ADMIN_GROUP && contactEmail.length > 1 && isEmailVerified==='' && isloginas && <Link className="dropdown-item" to="#" onMouseDown={(e) => this.onLoginAs(e,item.id,item.company_name)}>{LBL_LOGIN_AS_THIS_USER}</Link>}
                                                      <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.goToAffiliateProfile(e,item.id)}>{LBL_EDIT}</Link>
                                                      <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.company_name)}>{LBL_DELETE}</Link>
                                                </div>
                                            </div>
                                          }
                                            </td>                                            
                                        </tr>             
                                        
                                     )
                                  })      

                                }                                                
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll">&nbsp;</div>   
                     </div>
                  </div>                    
               </div>
               <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
               {"Are you sure you want to delete Affiliate '"+affiliateName+"'?"}
               </ModalWindow>
            </div>

            <Filter onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton} needParentCallBack='yes' onFilterClose={this.onFilterClose}  >
               <FilterAffiliate filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} />
            </Filter>

            {/* <Filter onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton} needParentCallBack='yes' onFilterClose={this.onFilterClose} >
               <div className="filter-category">
                     <h4>{LBL_STATUS}</h4> 
                     <div className="form-group">
                     <div className="form-group select-input">
                        <select onChange={(e) => this.onSelectStatus(e)} name="selStatus" value={statusActive} >  
                           <option value="" >{LBL_ALL}</option>
                           <option value='1' >{LBL_ACTIVE}</option>
                           <option value='0' >{LBL_DELETED}</option> 
                        </select>  
                     </div>
                     </div>
               </div>
              
               <div className="filter-category">              
                        <div className="row"> 
                            <div className="col-6"> <h4>
                            <div className="custom-checkbox" > 
                                    <input type="checkbox" id="includeDate" name="includeDate"  checked={includeDate} value={includeDate}  onChange={e => this.onDateCheck(e)} />
                                    <label className="checkbox" htmlFor="includeDate" ></label>
                                    <label htmlFor="includeDate" > &nbsp; {LBL_DATE_FROM}</label> 
                                </div></h4>
                            </div>
                            <div className="col-6 paddingTop5"> <h4>{LBL_DATE_TO}</h4></div>
                        </div>
                        <div className="form-group">
                            <div className="form-group"> 
                                <div className="row">
                                    <div className="col-6">
                                        <div className="calendar-input">  
                                            <DatePicker 
                                                selected={selectedStartDate}
                                                onChange={selected => this.onStartDateChange(selected)}
                                                name="startDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                //maxDate={new Date()}
                                                // minDate={new Date()}
                                                fixedHeight   
                                                disabled={!includeDate}       
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="calendar-input ">  
                                            <DatePicker 
                                                selected={selectedEndDate}
                                                onChange={selected => this.onEndDateChange(selected)}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                //maxDate={new Date()}
                                                minDate={new Date(selectedStartDate)}
                                                fixedHeight     
                                                disabled={!includeDate}         
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{paddingTop:paddingTopPix}}></div>
            </Filter> */}
         </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
      return {
         affiliates : state.affiliates.items,
         totalPage:state.affiliates.totalPage,
         status:state.affiliates.status,
         activity:state.affiliates.activity,
         numRows:state.affiliates.numRows,
         count:state.affiliates.count,
         errorData:state.affiliates.errorData,
         isFilterOn: state.commons.isFilterOn   
      }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
         affiliateListAction:affiliateListAction,
         affiliateDeleteAction:id=>affiliateDeleteAction(id),
         loginAsAction:loginAsAction,
         clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(AffiliateListComponent);
